import { SvgIcon, SvgIconProps } from '@mui/material';

const ChevronRightOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="ChevronRightOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M9.70504 6L8.29504 7.41L12.875 12L8.29504 16.59L9.70504 18L15.705 12L9.70504 6Z" />
    </SvgIcon>
  );
};

export default ChevronRightOutlined;
